<template>
  <v-row>
    <v-col v-for="(result,index) of liste" :key="index"
           cols="12" :md="result.title.style.md" :sm="result.title.style.sm"
    >
      <v-subheader class="sectionTitle">
        {{ result.title.name }}
      </v-subheader>
    
      <v-divider></v-divider>
      <v-row>
        <v-col v-for="(obj,index) of result.items" :key="index"
               cols="12" :md="obj.style.md" :sm="obj.style.sm">
          <v-list-item tow-line>
            <v-list-item-content>
              <v-list-item-title class="itemValue">
                {{ filee(obj) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ obj.subtitle }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {Container} from '@/model/static/Item'
export default {
  props: {
    fil: Function,
    resultList: Array
  },
  data:() =>({
    itm:Container.ProductItem
  }),
  computed:{
    liste() {
      return this.resultList
    },
    filee() {
      return this.fil
    }
  },
}
</script>

<style lang="scss" scoped>
.sectionTitle {
  margin-top: 1.4rem;
  font-weight: bold;
  font-size: 1.4rem !important;
}

.itemValue {
  // font-weight: bolder;
  font-size: 1.6rem !important;
  color: #666 !important;
}
</style>
